var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFinishAppLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M12.373 13.15a.97.97 0 0 0-.591 1.23l5.256 14.827a.97.97 0 0 0 1.24.592.97.97 0 0 0 .631-1.232l-5.294-14.826a.97.97 0 0 0-1.242-.592zm17.203 4.508l-2.91-8.407a.485.485 0 0 0-.833-.136c-1.222 1.552-3.045 1.455-5.091 1.397-2.327-.059-4.975-.136-6.303 2.705a.485.485 0 0 0 0 .368l2.977 8.408a.495.495 0 0 0 .34.31h.125c.117.001.231-.04.32-.116 1.794-1.61 3.55-1.649 5.411-1.697 2.017-.049 4.102-.097 5.944-2.366a.495.495 0 0 0 .02-.466zm-11.491 3.365l-1.26-3.568 5.197-1.843-1.474-4.14h.174c1.882.058 3.811.116 5.266-1.154l1.27 3.578-.068-.117-5.168 1.833 1.386 3.879a8.504 8.504 0 0 0-5.323 1.532zm6.4 5.1a.97.97 0 0 0-.97.97v1.32a1.62 1.62 0 0 1-1.59 1.648H5.935a1.62 1.62 0 0 1-1.64-1.6V8.9h4.258a1.842 1.842 0 0 0 1.842-1.832V2.91h12.102a1.62 1.62 0 0 1 1.639 1.6v1.94a.97.97 0 1 0 1.94 0v-1.94a3.568 3.568 0 0 0-3.57-3.54H9.359a.97.97 0 0 0-.233 0h-.097a.679.679 0 0 0-.281.185L5.75 4.063l-3.103 3.17a.97.97 0 0 0-.29.786v20.442A3.568 3.568 0 0 0 5.934 32h15.99a3.559 3.559 0 0 0 3.53-3.588v-1.319a.97.97 0 0 0-.97-.97zM8.455 6.964H5.75l1.358-1.387 1.348-1.329v2.715z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinishAppLight);
export default __webpack_public_path__ + "static/media/icon-finish-app-light.e3b862a467f71b5052a9307aee03b5b8.svg";
export { ForwardRef as ReactComponent };